export const namespaceOverrideQueryParam = 'o-namespace'

export const getNamespaceOverrideParam = (search: string) => {
  return new URLSearchParams(search).get(namespaceOverrideQueryParam)
}

export const appendNamespaceOverrideParam = (targetParams: URLSearchParams, namespaceOverride: string | null) => {
  if (namespaceOverride != null && !targetParams.has(namespaceOverrideQueryParam)) {
    targetParams.append(namespaceOverrideQueryParam, namespaceOverride)
  }
}
